<ng-container>
  <app-header *ngIf="this.oauthService.getAccessToken() && !externalApplication"></app-header>

  <div class="primary-router-container">
    <router-outlet (activate)='onActivate($event)'></router-outlet>
  </div>
  <div class="version-label">
    <small>v{{appVersion}}</small>
  </div>
  <!-- <app-footer *ngIf="this.oauthService.getAccessToken()"></app-footer> -->
</ng-container>

<ng-container *ngIf="!this.oauthService.getAccessToken()">
  <div style="z-index: 999;
        display: -webkit-box;
        display: -moz-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-flex-direction: row;
        -moz-box-flex-direction: row;
        -webkit-flex-direction: row;
        flex-direction: row;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #272727">
      <div style="margin: auto; text-align:center; height: 110px">
        <img alt="Firstmac" style="width:350px; max-width: 90%" src="/assets/img/fmc-logo-white.png"/><br/><br/><br/>
        <h2 style="color: #fff;">Application Wizards</h2>
      </div>
    </div>
</ng-container>
